export const apps = {
  rust_public:
    'https://raw.githubusercontent.com/GamingAPI/definitions/main/bundled/rust_public.asyncapi.json',
  rust:
    'https://raw.githubusercontent.com/GamingAPI/definitions/main/bundled/rust.asyncapi.json',
};
